export const manifest = {
  screens: {
    scr_mfy8mt: { name: "Home — Hero", route: "/", position: {"x":160,"y":1820} },
    scr_1tdvb4: { name: "Attention & System", route: "/#platform", position: {"x":1560,"y":1820} },
    scr_0gx7lu: { name: "Three Products", route: "/#products", position: {"x":2960,"y":1820} },
    scr_402j7h: { name: "For Brands", route: "/#for-brands", position: {"x":4360,"y":1820} },
    scr_q1emyu: { name: "Pricing", route: "/#pricing", position: {"x":5760,"y":1820} },
    scr_phizhk: { name: "Start a Campaign", route: "/#start", position: {"x":7160,"y":1820} },
    scr_ecxmr6: { name: "Gone Fishing", route: "/products/gone-fishing", position: {"x":160,"y":3800} },
    scr_w2ieu8: { name: "Surprise Sampling", route: "/products/surprise", position: {"x":1560,"y":3800} },
    scr_odlned: { name: "Sponsor AI", route: "/products/sponsor-ai", position: {"x":2960,"y":3800} },
    scr_zdw1z2: { name: "Platform Overview", route: "/platform", position: {"x":160,"y":5780} },
    scr_b86elr: { name: "Media Loop", route: "/platform#media-loop", position: {"x":1560,"y":5780} },
    scr_hqz8ob: { name: "Evidence Layer", route: "/platform#evidence", position: {"x":2960,"y":5780} },
    scr_l8jirh: { name: "Platform CTA", route: "/platform#strategy", position: {"x":4360,"y":5780} },
    scr_cta0xq: { name: "Brand Portal — 30 Days", route: "/brand", state: {"timeframe":"30 DAYS"}, position: {"x":160,"y":7760} },
    scr_n58ukj: { name: "Brand Portal — 7 Days", route: "/brand", state: {"timeframe":"7 DAYS"}, position: {"x":1560,"y":7760} },
    scr_aztew6: { name: "Brand Portal — Full Campaign", route: "/brand", state: {"timeframe":"CAMPAIGN"}, position: {"x":2960,"y":7760} },
    scr_yo7nl3: { name: "Investor", route: "/investor", position: {"x":0,"y":0}, isDefaultRow: true },
  },
  sections: {
    sec_o1n8xs: { name: "Homepage sections", x: 0, y: 1600, width: 8520, height: 1180 },
    sec_8aa4p1: { name: "Product pages", x: 0, y: 3580, width: 4320, height: 1180 },
    sec_gb2zew: { name: "Platform", x: 0, y: 5560, width: 5720, height: 1180 },
    sec_va1q25: { name: "Brand Portal", x: 0, y: 7540, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "screen", id: "scr_yo7nl3" },
    { kind: "section", id: "sec_o1n8xs", children: [
      { kind: "screen", id: "scr_mfy8mt" },
      { kind: "screen", id: "scr_1tdvb4" },
      { kind: "screen", id: "scr_0gx7lu" },
      { kind: "screen", id: "scr_402j7h" },
      { kind: "screen", id: "scr_q1emyu" },
      { kind: "screen", id: "scr_phizhk" },
    ] },
    { kind: "section", id: "sec_8aa4p1", children: [
      { kind: "screen", id: "scr_ecxmr6" },
      { kind: "screen", id: "scr_w2ieu8" },
      { kind: "screen", id: "scr_odlned" },
    ] },
    { kind: "section", id: "sec_gb2zew", children: [
      { kind: "screen", id: "scr_zdw1z2" },
      { kind: "screen", id: "scr_b86elr" },
      { kind: "screen", id: "scr_hqz8ob" },
      { kind: "screen", id: "scr_l8jirh" },
    ] },
    { kind: "section", id: "sec_va1q25", children: [
      { kind: "screen", id: "scr_cta0xq" },
      { kind: "screen", id: "scr_n58ukj" },
      { kind: "screen", id: "scr_aztew6" },
    ] },
  ],
}
